import React from "react";
import styles from "./styles.css";

const RippleButton = () => {
    return (
        <div styleName="styles.rippleContainer">
            <span styleName="styles.ripple styles.pinkBg" />
            <span styleName="styles.ripple styles.pinkBg" />
            <span styleName="styles.ripple styles.pinkBg" />
        </div>
    );
};

export default RippleButton;
